import { Modal, ModalHeaderWithActions, ModalBody } from '@evertrue/et-components';
import { PropTypes } from 'base/react-libs';
import FormField from 'components/forms/form-field';

const BulkDeleteEmailModal = ({ onClose = () => {}, isOpen, handleBulkDelete = () => {}, emailType }) => {
  const handleSubmit = async () => {
    await handleBulkDelete();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} closeModal={onClose}>
      <ModalHeaderWithActions
        title={`Discard Selected ${emailType}`}
        closeModal={onClose}
        submitLabel="Confirm"
        onSubmit={handleSubmit}
        disableSubmit={false}
      />
      <ModalBody>
        <FormField label={`Selected ${emailType}`} boldLabel={true} inlineLabel={false}>
          <span>{`Are you sure you want to discard the selected ${emailType}?`}</span>
        </FormField>
      </ModalBody>
    </Modal>
  );
};
BulkDeleteEmailModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  handleBulkDelete: PropTypes.func,
  emailType: PropTypes.string,
};

export default BulkDeleteEmailModal;
